module.exports = __webpack_public_path__ + "static/img/3.e5e4366.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka3/3.jpg
// module id = aS2z
// module chunks = 16